import script from "./form-guide.vue?vue&type=script&setup=true&lang=js"
export * from "./form-guide.vue?vue&type=script&setup=true&lang=js"

import "./form-guide.vue?vue&type=style&index=0&id=2cfb0d7f&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfb0d7f"]])

export default __exports__